export default __webpack_public_path__ + "cbb0fd2687a949b0b24134a0e8ee561e.png";